import { gql } from "@apollo/client";

const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription($subscriptionId: ID!, $accessToken: String) {
    cancelSubscription(
      subscriptionId: $subscriptionId
      accessToken: $accessToken
    ) {
      success
      error
      result {
        id
        status
        stripe_subscription_status
        plans
      }
    }
  }
`;

export default CANCEL_SUBSCRIPTION;
